/**
 * Guest Socket.IO Client
 * ──────────────────────
 * A SEPARATE singleton from src/socket/socketClient.js. The guest connection
 * authenticates with a scoped `guestToken` (handshake.auth.guestToken) instead
 * of a user JWT, and the backend places it only in its `conv:<id>` room.
 *
 * The authenticated socket and the guest socket are never used at the same time
 * (the guest flow only runs when the visitor is NOT logged in), so the two
 * singletons don't interfere.
 *
 *   connectGuestSocket(token) → socket
 *   getGuestSocket()          → socket | null
 *   disconnectGuestSocket()
 */

import { io } from 'socket.io-client';



// CRA-style env first so the bundle builds under Create React App; the hosted
// fallback matches the rest of the app.
const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'https://giggs-backend-ff5df60a245f.herokuapp.com/';

let guestSocket = null;

export const connectGuestSocket = (guestToken) => {
  if (!guestToken) {
    console.warn('[guest-socket] no guest token — skipping connect');
    return null;
  }

  // Reuse an existing socket; just refresh its auth + reconnect if needed.
  if (guestSocket) {
    guestSocket.auth = { guestToken };
    if (!guestSocket.connected) guestSocket.connect();
    return guestSocket;
  }

  guestSocket = io(SOCKET_URL, {
    auth: { guestToken },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    autoConnect: true,
  });

  guestSocket.on('connect', () =>
    console.log('[guest-socket] connected', guestSocket.id)
  );
  guestSocket.on('disconnect', (reason) =>
    console.log('[guest-socket] disconnected:', reason)
  );
  guestSocket.on('connect_error', (err) =>
    console.error('[guest-socket] connect_error:', err.message)
  );

  return guestSocket;
};

export const getGuestSocket = () => guestSocket;

export const disconnectGuestSocket = () => {
  if (guestSocket) {
    guestSocket.removeAllListeners();
    guestSocket.disconnect();
    guestSocket = null;
  }
};
